export default __webpack_public_path__ + "static/media/tv-light.f2000495.svg";